import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '@.layout';
import { Table2 } from '@.partials';
import { LinkHelper } from '@.services';
import { Button, Checkbox, Filter3 } from '@.ui';
import { isAllowArchiveBrand, isAllowRestoreBrand } from '@/entities/Brand';
import { PermissionProps } from '@/Types';

import { useAllBrandsPageControl } from '../lib/useAllBrandsPageControl';

export const BrandsAllPage: React.FC<PermissionProps> = (props) => {
    const allBrandsControl = useAllBrandsPageControl();

    const navigate = useNavigate();

    return (
        <Layout name="data" breadcrumbs={[{ name: 'Brands', current: true }]}>
            {allBrandsControl.modals}

            <h1>
                Brands
                <Button color="brown" text="Add brand" onClick={() => navigate(LinkHelper.dataBrandsAdd)} disabled={!props.permissions?.create} />
            </h1>

            <Table2 get={allBrandsControl.get} getData={allBrandsControl.getData} export="brands" item={allBrandsControl.items}>
                {{
                    filters: (handler) => (
                        <Filter3 onChange={handler}>
                            <Filter3.Search />
                            <Filter3.Boolean placeholder="Has image" name="has_image" />
                            {allBrandsControl.auth?.user?.is_super && <Filter3.Boolean placeholder="Archived" name="is_archived" />}
                        </Filter3>
                    ),
                    items: [
                        (item) => ({
                            link: LinkHelper.dataBrandId(item.id),
                            name: 'Name',
                            content: item.name,
                            sort: 'name',
                        }),
                        (item) => ({
                            content: <Checkbox value={item.has_image} isDisabled={true} />,
                            name: 'Has image',
                            sort: 'has_image',
                        }),
                    ],
                    actions: [
                        (item) => ({
                            type: 'edit',
                            link: LinkHelper.dataBrandsEditId(item.id),
                            disabled: !!item.deleted_at || !props.permissions?.update,
                        }),
                        (item) => ({
                            type: 'archive',
                            onClick: () => allBrandsControl.handleArchive(item.id),
                            disabled: !isAllowArchiveBrand(item) || !props.permissions?.delete,
                        }),
                        (item) => ({
                            type: 'restore',
                            onClick: () => allBrandsControl.handleRestore(item.id),
                            disabled: !isAllowRestoreBrand(item) || !props.permissions?.update,
                        }),
                        (item) => ({
                            type: 'destroy',
                            onClick: () => allBrandsControl.deleteBrand(item.id),
                            disabled: !props.permissions?.delete,
                        }),
                        (item) => ({
                            type: 'open',
                            link: LinkHelper.dataBrandId(item.id),
                        }),
                    ],
                }}
            </Table2>
        </Layout>
    );
};
